import React, { ReactNode } from "react";
import styled, { css } from "styled-components/macro";
import { mediaMin } from "styles/media";

const Text = styled.h2<{ color: "black" | "white" }>`
  font-size: 24px;
  font-weight: 500;
  line-height: 1.2;
  text-align: center;

  ${({ color, theme }) => {
    switch (color) {
      case "black":
        return css`
          color: ${theme.palette.black};
        `;
      case "white":
        return css`
          color: ${theme.palette.white};
        `;
    }
    return "";
  }}

  ${mediaMin.xs`
    font-size: 32px;
  `}

  ${mediaMin.sm`
    font-size: 40px;
  `}

  ${mediaMin.lg`
    font-size: 64px;
  `}
`;

export function SectionTitle({
  className = "",
  color = "black",
  children,
}: {
  className?: string;
  color?: "black" | "white";
  children: ReactNode;
}) {
  return (
    <Text className={className} color={color}>
      {children}
    </Text>
  );
}
